/* eslint-disable no-dupe-keys */
export default {
  advertisement_click_record: {
    name: '广告点击记录',
    // 属性（一般与对象内容匹配）
    prop: {
      advertisement: '广告',
      user: '用户',
      clicked_at: '点击时间',
      keyword: '关键词'
    }
    // Enum的属性

    // Boolean的属性

    // 标题
  }
}
